export default __webpack_public_path__ + "static/media/Red-BG-Start.ebb73763.svg";